import { Typography } from '@mui/material';

export function NotFound() {
    return (
        <Typography variant="h3" textAlign="center" sx={{ mt: 20 }}>
            404. Bad Url. Nothing here. Go away now.
        </Typography>
    );
}
